export const getAttachmentControlState = (
  config = {},
  {
    enableAttachment = false,
    agentMessageStarted = false,
    isAiConversation = false,
  } = {},
) => {
  const visible =
    config.hideAttachment !== true &&
    Boolean(
      config.sandBox ||
        config.connectToNextiva ||
        enableAttachment ||
        agentMessageStarted ||
        isAiConversation,
    );

  return {
    visible,
    interactive: visible && config.sandBox !== true,
  };
};
